function hslToRgba({ h, s, l }: { h: number; s: number; l: number }, alpha = 1): string {
  return `hsla(${h}, ${s}%, ${l}%, ${alpha})`;
}

const COMPARISON_COLORS = ['#8979FF', '#20A955', '#FF928A', '#3CC3DF', '#FFAE4C', '#EE53F1'];

export function getDistinctVibrantColors(
  count: number
): { fillColor: string; strokeColor: string }[] {
  const colors: { fillColor: string; strokeColor: string }[] = [];

  for (let i = 0; i < count; i++) {
    if (i < COMPARISON_COLORS.length) {
      const color = COMPARISON_COLORS[i];
      colors.push({
        fillColor: `${color}80`,
        strokeColor: color,
      });
    } else {
      const hue = Math.floor((i * 360) / count);
      const saturation = Math.floor(Math.random() * 20) + 75;
      const lightness = Math.floor(Math.random() * 15) + 45;
      const color = { h: hue, s: saturation, l: lightness };

      colors.push({
        fillColor: hslToRgba(color, 0.5),
        strokeColor: hslToRgba(color, 1),
      });
    }
  }

  return colors;
}
